import { xhr } from '@/api/config/Repository'
import MasterInfoFactoryRepositoryImpl from '../MasterInfoRepository'
import SupplierDetailsResponse from '@/services/masterInfo/models/SupplierDetailsResponse'
import SupplierDetailsDTO from '../dto/SupplierDetailsDTO'
import WarehouseDetailsResponse from '@/services/masterInfo/models/WarehouseDetailsResponse'
import WarehouseDetailsDTO from '../dto/WarehouseDetailsDTO'
import WarehouseRequest from '@/services/masterInfo/models/WarehouseRequest'
import SupplierRequest from '@/services/masterInfo/models/SupplierRequest'
export default class MasterInfoRepositoryImpl implements MasterInfoFactoryRepositoryImpl {
  async getSupplierDetailsData (param: SupplierRequest): Promise<SupplierDetailsResponse> {
    const queryString = 'countryList=' + param.countryList + '&supplierList=' + param.supplierList
    const endpoint = 'md/getSuppliers?' + queryString
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.get<SupplierDetailsDTO[]>(endpoint, { headers })
    return {
      status: response.status,
      content: response.data
    }
  }

  async getWarehouseDetailsData (param: WarehouseRequest): Promise<WarehouseDetailsResponse> {
    const queryString = 'countryList=' + param.countryList + '&warehouseList=' + param.warehouseList
    const endpoint = 'md/getAllWarehouses?' + queryString
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.get<WarehouseDetailsDTO[]>(endpoint, { headers })
    return {
      status: response.status,
      content: response.data
    }
  }
}
